import { render, staticRenderFns } from "./LexinKeyboardLangPrs.vue?vue&type=template&id=2843469c&"
import script from "./LexinKeyboardLangPrs.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangPrs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports